import { type RequestPayload, router } from "@inertiajs/core";
import { GlobalDocumentForm } from "../../../components/document/global/GlobalDocumentForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Group } from "../../../models/group";
import type { YearContext } from "../../../models/yearContext";
import { global_documents_path } from "../../../routes";

type GlobalDocumentCreateProps = {
  year_contexts: YearContext[];
  groups: Group[];
};

export default function GlobalDocumentCreate({ year_contexts, groups }: GlobalDocumentCreateProps) {
  const { pathWithYearContext } = useYearContext();

  return (
    <ContentShell title="Neues Globales Dokument" onBack={() => router.get(pathWithYearContext(global_documents_path))}>
      <GlobalDocumentForm
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Erstellen"
        onSubmit={(values: RequestPayload) =>
          router.post(pathWithYearContext(global_documents_path), values, {
            forceFormData: true,
          })
        }
      />
    </ContentShell>
  );
}
